webpackJsonp([9],{

/***/ 237:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(238);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(167)("9468ff8e", content, true);

/***/ }),

/***/ 238:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(166)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"ResetPassword.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 239:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_simple_vue_validator__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_simple_vue_validator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_simple_vue_validator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_leancloud_storage__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_leancloud_storage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_leancloud_storage__);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      old: '',
      password: '',
      repeat: '',
      submitted: false
    };
  },

  validators: {
    old: {
      debounce: 300,
      validator: function validator(v) {
        return __WEBPACK_IMPORTED_MODULE_1_simple_vue_validator__["Validator"].value(v).required('原密码必填');
      }
    },
    password: {
      debounce: 300,
      validator: function validator(v) {
        return __WEBPACK_IMPORTED_MODULE_1_simple_vue_validator__["Validator"].value(v).required('密码必填').minLength(6, '至少6位以上的密码');
      }
    },
    'repeat, password': {
      debounce: 300,
      validator: function validator(repeat, password) {
        if (this.submitted || this.validation.isTouched('repeat')) {
          return __WEBPACK_IMPORTED_MODULE_1_simple_vue_validator__["Validator"].value(repeat).required('请再次输入新密码').match(password, '两次密码不一致');
        }
      }
    }
  },
  methods: {
    reset: function reset() {
      var _this = this;

      this.submitted = true;
      this.$validate().then(function (isSuccess) {
        if (isSuccess) {
          __WEBPACK_IMPORTED_MODULE_2_leancloud_storage___default.a.User.current().updatePassword(_this.old, _this.password).then(function () {
            _this.$toast('密码已重置，请使用新密码登录');
            return __WEBPACK_IMPORTED_MODULE_2_leancloud_storage___default.a.User.logOut().then(function () {
              _this.$router.push('/auth');
            });
          }).catch(function (error) {
            if (error.code === 210) {
              _this.$toast('原密码不匹配');
            } else {
              _this.$toast(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(e));
            }
          });
        }
      });
    }
  }
});

/***/ }),

/***/ 240:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex flex-column flex-1"
  }, [_c('u-header', {
    attrs: {
      "show-back": ""
    }
  }, [_vm._v("修改密码")]), _vm._v(" "), _c('div', {
    staticClass: "scrollable container flex-1 flex flex-row"
  }, [_c('form', {
    staticClass: "flex-1",
    attrs: {
      "name": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.reset($event)
      }
    }
  }, [_c('u-input', {
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "请输入原密码",
      "autofocus": "",
      "tabindex": "1"
    },
    model: {
      value: (_vm.old),
      callback: function($$v) {
        _vm.old = $$v
      },
      expression: "old"
    }
  }, [(_vm.submitted && _vm.validation.hasError('old')) ? _c('span', {
    staticClass: "input-error",
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }, [_vm._v(_vm._s(_vm.validation.firstError('old')))]) : _vm._e()]), _vm._v(" "), _c('u-input', {
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "请输入新密码",
      "tabindex": "2"
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }, [(_vm.submitted && _vm.validation.hasError('password')) ? _c('span', {
    staticClass: "input-error",
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }, [_vm._v(_vm._s(_vm.validation.firstError('password')))]) : _vm._e()]), _vm._v(" "), _c('u-input', {
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "请再次输入新密码",
      "tabindex": "3"
    },
    model: {
      value: (_vm.repeat),
      callback: function($$v) {
        _vm.repeat = $$v
      },
      expression: "repeat"
    }
  }, [(_vm.validation.hasError('repeat')) ? _c('span', {
    staticClass: "input-error",
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }, [_vm._v(_vm._s(_vm.validation.firstError('repeat')))]) : _vm._e()]), _vm._v(" "), _c('u-button', {
    staticStyle: {
      "margin-top": "40px"
    },
    attrs: {
      "native-type": "submit"
    }
  }, [_vm._v("重置密码")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 275:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(237)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(239),
  /* template */
  __webpack_require__(240),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-069db0cf",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/9.0020063ee2d7e653db94.js